import { render } from "./AposButtonSplit.vue?vue&type=template&id=bdc757cc&scoped=true"
import script from "./AposButtonSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./AposButtonSplit.vue?vue&type=script&setup=true&lang=js"

import "./AposButtonSplit.vue?vue&type=style&index=0&id=bdc757cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc757cc"],['__file',"ui/ui/apos/components/AposButtonSplit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bdc757cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bdc757cc', __exports__)) {
    api.reload('bdc757cc', __exports__)
  }
  
  module.hot.accept("./AposButtonSplit.vue?vue&type=template&id=bdc757cc&scoped=true", () => {
    api.rerender('bdc757cc', render)
  })

}


export default __exports__